export function initialStoreName({ rankings }, { selectedStore }) {
  const { dataPerHour } = rankings
  const data = dataPerHour[0]
  const store = data && data.stores && data.stores.find(({ storeId }) => storeId === selectedStore)

  return store ? store.storeName : ''
}
